// extracted by mini-css-extract-plugin
export default {"container":"TransportOrderTemplate_container__fWHN2"};